import { type ReactNode, useEffect } from "react";
import { useAuth } from "./AuthProvider";
import { AuthStageLoading } from "./AuthStage";

interface ProtectedRouteProps {
  children: ReactNode;
  onRedirect: (path: string) => void;
}

export function ProtectedRoute({ children, onRedirect }: ProtectedRouteProps) {
  const { status } = useAuth();

  useEffect(() => {
    if (status === "anonymous" || status === "session_expired") {
      onRedirect(loginRedirectPath());
    }
  }, [onRedirect, status]);

  if (status === "loading") {
    return (
      <AuthStageLoading
        eyebrow="Secure session"
        title="Opening Starling"
        body="Checking your session before the workbench opens."
      />
    );
  }

  if (status !== "authenticated") {
    return null;
  }

  return children;
}

function loginRedirectPath() {
  const returnTo = safeCurrentReturnTo();
  return returnTo === "/"
    ? "/login"
    : `/login?return_to=${encodeURIComponent(returnTo)}`;
}

function safeCurrentReturnTo() {
  const path =
    `${window.location.pathname}${window.location.search}${window.location.hash}` ||
    "/";
  if (
    !path.startsWith("/") ||
    path.startsWith("//") ||
    path === "/login" ||
    path.startsWith("/login?") ||
    path.startsWith("/login/") ||
    path === "/auth" ||
    path.startsWith("/auth/") ||
    path === "/setup" ||
    path.startsWith("/setup/")
  ) {
    return "/";
  }
  return path;
}
